import { useGetMatchesQuery, useGetPopularEventsQuery } from '@/store/api/sportsApi';

export const usePopularEvents = () => {
  const { data: popularEventsData } = useGetPopularEventsQuery();
  const { data: allFixtures } = useGetMatchesQuery({});

  const events = popularEventsData?.events ?? [];
  const startTimeById = new Map(
    (allFixtures?.fixture ?? []).map((fixture) => [String(fixture.id), fixture.startTime])
  );

  return { events, getStartTime: (eventId: string) => startTimeById.get(eventId) };
};
